import API from './config'

export const BalancesValidationsAPI = {

    async getBalancesByMonthAndYear(clientId, month, year) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/balances_validations/getBalancesByMonthAndYear?client_id=${clientId}&month=${month}&year=${year}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getBalancesAccountsByMonthAndYear(clientId, month, year) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/balances_validations/getBalancesAccountsByMonthAndYear?client_id=${clientId}&month=${month}&year=${year}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getSumBalancesByMonthAndYear(clientId, month, year, accountRegimeId = null) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const regimeQuery = accountRegimeId ? `&account_regime_id=${accountRegimeId}` : '';
            const response = await API.get(`/balances_validations/getSumBalancesByMonthAndYear?client_id=${clientId}&month=${month}&year=${year}${regimeQuery}`, config);

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getSumBalancesByPeriod(clientId, startDate, endDate) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/balances_validations/getSumBalancesByPeriod?client_id=${clientId}&start_date=${startDate}&end_date=${endDate}`, config);

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getAllClientsSumAccountBalancesByMonthAndYearAndConsultingId(month, year, consultingId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/balances_validations/getAllClientsSumAccountBalancesByMonthAndYearAndConsultingId?consulting_id=${consultingId}&month=${month}&year=${year}`, config);

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getAllClientsSumBalancesByMonthAndYearAndConsultingId(month, year, consultingId) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/balances_validations/getAllClientsSumBalancesByMonthAndYearAndConsultingId?consulting_id=${consultingId}&month=${month}&year=${year}`, config);

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getBalancesByPeriodAndTitleAssetsIds(clientId, startDate, endDate) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/balances_validations/getBalancesByPeriodAndTitleAssetsIds?client_id=${clientId}&start_date=${startDate}&end_date=${endDate}`, config);

            return {
                success: true,
                data: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },


    async getBalancesWithAssetInitsInfosByMonthAndYear(clientId, month, year) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.get(`/balances_validations/getBalancesWithAssetInitsInfosByMonthAndYear?client_id=${clientId}&month=${month}&year=${year}`, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getAssetBalancesByPeriods(assetId, periods) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/balances_validations/getAssetBalancesByPeriods`, {
                asset_id: assetId,
                periods: periods
            }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

    async getTitleAssetBalancesByPeriods(assetId, periods) {
        const config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post(`/balances_validations/getTitleAssetBalancesByPeriods`, {
                asset_id: assetId,
                periods: periods
            }, config);

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            return {
                success: false,
                body: error.response.data
            };
        }
    },

}